export const locale = {
    lang: 'tr',
    data: {
      'CONFIGURACION': {
        'CABECERA':{
          'TITULO': 'AYARLAR',
          'DESCRIP': 'ayarlar'
        },
        'BOTONES':{
          'BOT1':{
            'TITULO': 'Katılımcı verisini yükle',
            'BOTON': 'Ayarla'
          },
          'BOT2':{
            'TITULO': 'Şirket logosunu yükle',
            'BOTON': 'Ayarla'
          },
          'BOT3':{
            'TITULO': 'Teknik gereklilikler hakkında bilgilendirme',
            'BOTON': 'Daha fazla göster'
          }
        },
        'BD':{
          'TITUHEAD': 'Katılımcı verisini yükle',
          'INFO': 'Sisteme katılımcı verilerinin yüklenmesi',
          'BOTONES':{
            'DescTemp': 'Katılımcı verisi şablonunu indir'
          },
          'MENSAJES':{
            'CARGABD': 'Veritabanını yükle',
            'STATUS': 'DURUM',
            'CORRECTO': 'Veritabanı yüklemesi başarılı',
            'ERROR': 'Veritabanı yüklenirken hata oluştu'
          }
        },
        'LOGO':{
          'TITUHEAD': 'Şirket logosu yükleniyor',
          'INFO': 'Şirket logonuzu yükleyin',
          'MENSAJES':{
            'CARGABD': 'Logoyu yükle',
            'STATUS': 'DURUM',
            'CORRECTO': 'Logo yüklemesi başarılı',
            'ERROR': 'Logo yüklenirken hata oluştu'
          }
        },
        'REQTEC':{
          'TITUHEAD': 'Teknik gereklilikler hakkında bilgilendirme',
          'INFO': 'Optimum operasyon için platform gereklilikleri',
          'MENSAJES':{
            'CARGA': '',
            'STATUS': 'DURUM',
            'CORRECTO': 'Yükleme başarılı',
            'ERROR': 'Yükleme yapılırken hata oluştu '
          }
        }
      }
    }
};
